module.exports = __webpack_public_path__ + "img/unionpay@2x.9c160fd0.png";